import React, { type FC } from 'react'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { FormControl, Grid, InputLabel } from '@mui/material'
import { useAppSelector } from '../../../redux/hooks'
import { type DeviceForProvisionWithoutId } from '../../../redux/admin/admin-device-provisions-types'
import type { RootState } from '../../../redux/store'

type FieldType = keyof DeviceForProvisionWithoutId

interface Props {
  deviceForProvision: DeviceForProvisionWithoutId
  valueChanged: (field: FieldType, value: string) => void
}

export const DeviceForProvisionFields: FC<Props> = ({ deviceForProvision, valueChanged }) => {
  const loadingDeviceProfiles = useAppSelector<boolean>((state: RootState) => state.adminDeviceProvisions.loadingDeviceProfiles)
  const deviceProfiles = useAppSelector<string[]>((state: RootState) => state.adminDeviceProvisions.deviceProfiles)

  return (

        <div>
            <Grid item container spacing={2}>
                <Field deviceForProvision={deviceForProvision} label='Serial Number' field='serialNumber'
                       valueChanged={valueChanged}/>
                <Field deviceForProvision={deviceForProvision} label='Dev EUI' field='devEUI'
                       valueChanged={valueChanged}/>
            </Grid>
            <Grid item container>
                <Field deviceForProvision={deviceForProvision} label='App EUI' field='appEUI'
                       valueChanged={valueChanged}/>
            </Grid>
            <Grid item container>
                <Grid item xs>
                    <TextField
                        fullWidth
                        id='dfp-appKey'
                        value={deviceForProvision.appKey}
                        onChange={(event) => {
                          valueChanged('appKey', event.target.value)
                        }}
                        label='App key'
                        variant='standard'
                    />
                </Grid>
            </Grid>
            <Grid item container style={{ paddingTop: '15px' }}>
                <Grid item xs>
                    {loadingDeviceProfiles &&
                      <span>Ladataan profiileja...</span>}
                    {!loadingDeviceProfiles && (
                        <FormControl style={{ width: '100%' }}>
                            <InputLabel>
                                Valitse profiili
                            </InputLabel>
                            <Select
                                fullWidth
                                value={deviceForProvision.deviceProfileId}
                                onChange={(event) => {
                                  valueChanged('deviceProfileId', event.target.value)
                                }}
                                variant='standard'
                            >
                                {deviceProfiles.map((profile: string) => <MenuItem key={profile}
                                                                                   value={profile}>{profile}</MenuItem>)}
                            </Select>
                        </FormControl>
                    )}
                </Grid>
            </Grid>
        </div>
  )
}

/* Sub-Components */

interface FieldProps {
  deviceForProvision: DeviceForProvisionWithoutId
  label: string
  field: FieldType
  valueChanged: (field: FieldType, value: string) => void
}

const Field: FC<FieldProps> = ({ deviceForProvision, label, field, valueChanged }) => (
    <Grid item xs>
        <TextField
            fullWidth
            id={`dfp-${field}`}
            value={deviceForProvision?.[field]}
            onChange={(event) => {
              valueChanged(field, event.target.value)
            }}
            label={label}
            variant='standard'
        />
    </Grid>
)
